var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexpage",attrs:{"id":"app"}},[_c('HeaderBox',{attrs:{"item":{
      homeUrl: 'index.html',
      cateUrl: 'category/'
    }}}),_c('article',{staticClass:"mainContent"},[_vm._m(0),_vm._m(1),_vm._m(2),_c('section',{staticClass:"topWideColWarp",attrs:{"id":"top5"}},[_vm._m(3),_c('div',{staticClass:"topWideColContentBox  pcTopWideColContentBox box1",attrs:{"id":"topWideColContentBox"}},_vm._l((_vm.sortedTop5ListByRank),function(list){return _c('div',{key:list[4],staticClass:"topWideColContent"},[_c('WideCol',{attrs:{"item":{
              no: list[0],
              categoryId: list[1],
              categoryName: list[2],
              rank: list[3],
              magazineId: list[4],
              customMagazineDescription: list[5],
              authorComment: list[6],
              userComment: list[7],
              magazineTitle: list[8],
              coverImage: list[9],
              cycleType: list[10],
              magazineIdView: list[11],
              magazineDescription: list[12],
              free: list[13],
              firstMonthPayFlag: list[14],
              basicPriceWithTax: list[15]
            }}})],1)}),0),_c('div',{staticClass:"topWideColContentBox spTopWideColContentBox box1",attrs:{"id":"topWideColContentBox"}},_vm._l((_vm.revSortedTop5ListByRank),function(list){return _c('div',{key:list[4],staticClass:"topWideColContent"},[_c('SpWideCol',{attrs:{"item":{
              no: list[0],
              categoryId: list[1],
              categoryName: list[2],
              rank: list[3],
              magazineId: list[4],
              customMagazineDescription: list[5],
              authorComment: list[6],
              userComment: list[7],
              magazineTitle: list[8],
              coverImage: list[9],
              cycleType: list[10],
              magazineIdView: list[11],
              magazineDescription: list[12],
              free: list[13],
              firstMonthPayFlag: list[14],
              basicPriceWithTax: list[15]
            }}})],1)}),0)]),_c('section',{staticClass:"secondSection",attrs:{"id":"new-face"}},[_c('div',{staticClass:"topWideColWarp"},[_vm._m(4),_c('div',{staticClass:"topWideColContentBox pcTopWideColContentBox box1"},_vm._l((_vm.sortedNewFaceListByRank),function(list){return _c('div',{key:list[4],staticClass:"topWideColContent"},[_c('WideCol',{attrs:{"item":{
                no: list[0],
                categoryId: list[1],
                categoryName: list[2],
                rank: list[3],
                magazineId: list[4],
                customMagazineDescription: list[5],
                authorComment: list[6],
                userComment: list[7],
                magazineTitle: list[8],
                coverImage: list[9],
                cycleType: list[10],
                magazineIdView: list[11],
                magazineDescription: list[12],
                free: list[13],
                firstMonthPayFlag: list[14],
                basicPriceWithTax: list[15]
              }}})],1)}),0),_c('div',{staticClass:"topWideColContentBox spTopWideColContentBox box1",attrs:{"id":"topWideColContentBox"}},_vm._l((_vm.revSortedNewFaceListByRank),function(list){return _c('div',{key:list[4],staticClass:"topWideColContent"},[_c('SpWideCol',{attrs:{"item":{
                no: list[0],
                categoryId: list[1],
                categoryName: list[2],
                rank: list[3],
                magazineId: list[4],
                customMagazineDescription: list[5],
                authorComment: list[6],
                userComment: list[7],
                magazineTitle: list[8],
                coverImage: list[9],
                cycleType: list[10],
                magazineIdView: list[11],
                magazineDescription: list[12],
                free: list[13],
                firstMonthPayFlag: list[14],
                basicPriceWithTax: list[15]
              }}})],1)}),0)])]),_c('section',{staticClass:"thaadSection",attrs:{"id":"media"}},[_c('div',{staticClass:"topnNarrowWarp"},[_vm._m(5),_c('div',{staticClass:"topNarrowCateContent"},[_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedNewsListByRank,
              cateTitle: 'MAG2 NEWS賞',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-news.svg',
              mediaId: 'news'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedMoneyListByRank,
              cateTitle: 'MONEY VOICE賞',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-money.svg',
              mediaId: 'money'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedTripeListByRank,
              cateTitle: 'TRiP EDiTOR賞',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-tripeditor.svg',
              mediaId: 'tripeditor'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedBythemListByRank,
              cateTitle: 'by them賞',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-bythem.svg',
              mediaId: 'bythem'
            }}})],1)])]),_c('section',{staticClass:"foursSection",attrs:{"id":"category"}},[_c('div',{staticClass:"topnNarrowWarp"},[_vm._m(6),_c('div',{staticClass:"topNarrowCateContent flexWrap"},[_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedBusinessListByRank,
              cateTitle: 'ビジネス',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-business.svg',
              mediaId: 'business'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedNewsCommentaryListByRank,
              cateTitle: '時事解説',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-news-commentary.svg',
              mediaId: 'news-commentary'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedJournalismListByRank,
              cateTitle: 'ジャーナリズム',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-journalism.svg',
              mediaId: 'journalism'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedSpecialtyListByRank,
              cateTitle: '専門情報',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-specialty.svg',
              mediaId: 'specialty'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedManagementListByRank,
              cateTitle: '起業・経営',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-management.svg',
              mediaId: 'management'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedAssetStockListByRank,
              cateTitle: '資産運用（株式）',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-asset-stock.svg',
              mediaId: 'asset-stock'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedAssetFxListByRank,
              cateTitle: '資産運用（FX・先物・債券）',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-asset-fx.svg',
              mediaId: 'asset-fx'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedAssetEsListByRank,
              cateTitle: '資産運用（不動産・その他）',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-asset-es.svg',
              mediaId: 'asset-es'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedPoliticalListByRank,
              cateTitle: '政治経済',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-political.svg',
              mediaId: 'political'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedCareerListByRank,
              cateTitle: 'キャリアアップ',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-career.svg',
              mediaId: 'career'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedKnowledgeListByRank,
              cateTitle: '知識・ノウハウ',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-knowledge.svg',
              mediaId: 'knowledge'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedColumnListByRank,
              cateTitle: 'コラム',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-column.svg',
              mediaId: 'column'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedPsychologyListByRank,
              cateTitle: 'こころ',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-psychology.svg',
              mediaId: 'psychology'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedMentalTrainingListByRank,
              cateTitle: 'メンタルトレーニング',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-mental-training.svg',
              mediaId: 'mental-training'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedSelfDevelopementListByRank,
              cateTitle: '自分磨き',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-self-developement.svg',
              mediaId: 'self-developement'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedSafetyListByRank,
              cateTitle: '安全・防災',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-safety.svg',
              mediaId: 'safety'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedLanguageListByRank,
              cateTitle: '語学・資格',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-language.svg',
              mediaId: 'language'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedEducationListByRank,
              cateTitle: '教育',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-education.svg',
              mediaId: 'education'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedHobbyListByRank,
              cateTitle: '趣味・娯楽',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-hobby.svg',
              mediaId: 'hobby'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedLifeListByRank,
              cateTitle: '生活',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-life.svg',
              mediaId: 'life'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedLoveListByRank,
              cateTitle: '恋愛',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-love.svg',
              mediaId: 'love'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedHealthListByRank,
              cateTitle: '健康',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-health.svg',
              mediaId: 'health'
            }}}),_c('NarrowCol',{attrs:{"item":{
              list: _vm.sortedEntertainmentListByRank,
              cateTitle: 'エンタメ',
              src:
                'https://www.mag2.com/events/mag2year/2019/images/t-entertainment.svg',
              mediaId: 'entertainment'
            }}})],1)])]),_c('CategoryButtons',{attrs:{"item":{
        cateUrl: 'category/'
      }}}),_c('sns-share-buttons'),_c('OldMag2Year'),_c('IncFooter',{attrs:{"item":{
        copyYear: _vm.copyYear
      }}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"headerWarp align-items-center"},[_c('figure',{staticClass:"headerLogpBox"},[_c('a',{attrs:{"href":"./"}},[_c('img',{attrs:{"src":require("@/assets/img/header-award-logo.svg"),"alt":""}})])]),_c('div',{staticClass:"headerThumbnailBox"},[_c('img',{attrs:{"src":require("@/../public/assets/img/award-logo-illustration.svg"),"alt":""}})]),_c('figure',{staticClass:"headerSubTitleBox"},[_c('img',{attrs:{"src":require("@/assets/img/resultAnnouncement.png"),"alt":""}}),_c('span',[_vm._v("「今年いちばん読みたい・読んでもらいたいメルマガ」という視点から、その年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。 今回も数多くの投票が集まりました。 投票にご協力いただいた読者の皆様、誠にありがとうございました。")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee marquee-top-pc"},[_c('div',{staticClass:"marquee__inner",attrs:{"aria-hidden":"true"}},[_c('span',[_vm._v("MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"spHeaderWarp"},[_c('figure',{staticClass:"spHeaderLogpBox row align-items-center"},[_c('a',{attrs:{"href":"./"}},[_c('img',{attrs:{"src":require("@/assets/img/header-award-logo.svg"),"alt":""}})])]),_c('div',{staticClass:"spHeaderSubTitleBox vertical",staticStyle:{"display":"flex"}},[_c('span',{staticStyle:{"letter-spacing":"0.8px","margin":"0 auto","display":"block"}},[_c('img',{staticClass:"spHeaderImg",attrs:{"src":require("@/assets/img/spResultAnnouncement.png"),"alt":""}}),_vm._v(" 「今年いちばん読みたい・読んでもらいたいメルマガ」という視点から、その年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。 今回も数多くの投票が集まりました。投票にご協力いただいた読者の皆様、誠にありがとうございました。")])]),_c('ul',{staticClass:"ankerLinkUl ankerLinkUl-middle",attrs:{"id":"headerDownLine"}},[_c('li',{staticClass:"ankerLinkLi underEyecath"},[_c('a',{attrs:{"href":"#top5"}},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-top5.svg","alt":""}}),_vm._v("総合大賞")])]),_c('li',{staticClass:"ankerLinkLi underEyecath"},[_c('a',{attrs:{"href":"#new-face"}},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-new-face.svg","alt":""}}),_vm._v("新人賞")])]),_c('li',{staticClass:"ankerLinkLi underEyecath"},[_c('a',{attrs:{"href":"#media"}},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-media.svg","alt":""}}),_vm._v("メディア賞")])]),_c('li',{staticClass:"ankerLinkLi underEyecath"},[_c('a',{attrs:{"href":"#category"}},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-top5.svg","alt":""}}),_vm._v("部門別賞")])])]),_c('div',{staticClass:"marquee-sp"},[_c('div',{staticClass:"marquee"},[_c('div',{staticClass:"marquee__inner",attrs:{"aria-hidden":"true"}},[_c('span',[_vm._v("MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topWideColTitleBox box2"},[_c('div',{staticClass:"topWideColTitleBoxSubTitle"},[_vm._v(" 今年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。 ２０２０年度「いちばん読みたい・読んでもらいたいメルマガ」に輝いた総合大賞５誌を発表します。 ")]),_c('div',{staticClass:"topWideColTitleBoxIconAndTitle"},[_c('figure',{staticClass:"topWideColTitleBoxIcon"},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-top5.svg","alt":""}})]),_c('div',{staticClass:"topWideColTitleBoxTitle"},[_vm._v("総合大賞")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topWideColTitleBox box2"},[_c('div',{staticClass:"topWideColTitleBoxSubTitle"},[_vm._v(" ２０２０年に創刊されたメルマガの中から「いちばん読みたい・読んでもらいたいメルマガ」に輝いた新人賞５誌を発表します。 ")]),_c('div',{staticClass:"topWideColTitleBoxIconAndTitle"},[_c('figure',{staticClass:"topWideColTitleBoxIcon"},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-top5.svg","alt":""}})]),_c('div',{staticClass:"topWideColTitleBoxTitle"},[_vm._v("新人賞")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topnNarrowTitleBox"},[_c('figure',{staticClass:"topNarrowIcon"},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-top5.svg","alt":""}})]),_c('div',{staticClass:"topNarrowCateTitle color_gold"},[_vm._v(" MEDIA"),_c('br'),_vm._v("メディア賞 ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topnNarrowTitleBox"},[_c('figure',{staticClass:"topNarrowIcon"},[_c('img',{attrs:{"src":"https://www.mag2.com/events/mag2year/2019/images/t-section.svg","alt":""}})]),_c('div',{staticClass:"topNarrowCateTitle color_gold"},[_vm._v(" CATEGORY"),_c('br'),_vm._v("部門別賞 ")])])}]

export { render, staticRenderFns }